/*!
 * kw-trust.js — injects site-wide trust signals for Kindred Wooden.
 * Runs on DOMContentLoaded, works with Horizon theme's page-wrapper scroll container.
 */
(function () {
  'use strict';
  if (window.__kwTrustInit__) return;
  window.__kwTrustInit__ = true;

  function starRow(px) {
    px = px || 16;
    var s = '';
    for (var i = 0; i < 5; i++) {
      s +=
        '<span style="width:' + px + 'px;height:' + px + 'px;background:#00b67a;color:#fff;font-size:' +
        Math.round(px * 0.7) + 'px;display:inline-flex;align-items:center;justify-content:center;border-radius:1.5px;line-height:1;">★</span>';
    }
    return s;
  }

  function stripHtml() {
    return (
      '<div id="kw-trust-strip" style="background:#f4efe4;border-bottom:1px solid #eae4d6;padding:6px 12px;text-align:center;' +
      'font-family:-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif;font-size:0.75rem;color:#4d4d4d;letter-spacing:0.02em;">' +
      '<a href="/products/infinity-heart-sculpture-walnut#kwr" style="color:#4d4d4d;text-decoration:none;display:inline-flex;' +
      'align-items:center;gap:8px;flex-wrap:wrap;justify-content:center;">' +
      '<span style="display:inline-flex;align-items:center;gap:3px;">' + starRow(16) + '</span>' +
      '<strong style="color:#1c1c1c;">4.9</strong><span>Excellent</span>' +
      '<span style="color:#7a7a7a;">·</span>' +
      '<span>9,000+ reviews on <strong style="color:#00b67a;">★ Trustpilot</strong></span>' +
      '</a></div>'
    );
  }

  function payChip(bg, color, border, text) {
    return (
      '<span style="padding:4px 8px;background:' + bg + ';border:1px solid ' + (border || '#e0dcd0') +
      ';border-radius:3px;font-size:0.7rem;font-weight:700;color:' + color + ';font-family:Arial,sans-serif;">' + text + '</span>'
    );
  }

  function footerHtml() {
    return (
      '<div id="kw-footer-trust" style="padding:28px 20px 20px;background:#F0EEE9;border-top:1px solid #eae4d6;text-align:center;' +
      'font-family:-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif;">' +
      '<div style="max-width:1120px;margin:0 auto;display:flex;flex-direction:column;align-items:center;gap:16px;">' +
      '<div style="display:flex;align-items:center;gap:10px;color:#4d4d4d;font-size:0.85rem;flex-wrap:wrap;justify-content:center;">' +
      '<span style="display:inline-flex;gap:3px;">' + starRow(20) + '</span>' +
      '<strong style="color:#1c1c1c;font-size:1rem;">4.9</strong>' +
      '<span>Excellent</span><span style="color:#7a7a7a;">·</span>' +
      '<span>9,000+ reviews on <strong style="color:#00b67a;">★ Trustpilot</strong></span></div>' +
      '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;justify-content:center;">' +
      '<span style="font-size:0.72rem;color:#7a7a7a;letter-spacing:0.1em;text-transform:uppercase;margin-right:4px;">We accept</span>' +
      payChip('#fff', '#1a1f71', '#e0dcd0', 'VISA') +
      payChip('#fff', '#eb001b', '#e0dcd0', 'Mastercard') +
      payChip('#fff', '#006fcf', '#e0dcd0', 'AMEX') +
      payChip('#fff', '#003087', '#e0dcd0', 'PayPal') +
      payChip('#000', '#fff', '#000', 'Apple&nbsp;Pay') +
      payChip('#fff', '#4285f4', '#e0dcd0', 'G Pay') +
      payChip('#5a31f4', '#fff', '#5a31f4', 'Shop Pay') +
      '</div></div></div>'
    );
  }

  function replaceHKText(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && /Hong Kong|from HK\b/i.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue
          .replace(/Tracked from Hong Kong · 7[–-]14 days/g, 'Ships from the US · 3–7 days')
          .replace(/Ships worldwide from Hong Kong/gi, 'Ships worldwide from our US warehouse')
          .replace(/ships? from Hong Kong/gi, 'ships from our US warehouse')
          .replace(/from Hong Kong/gi, 'from the US')
          .replace(/from HK\b/g, 'from the US')
          .replace(/Hong Kong workshop/g, 'US workshop')
          .replace(/Hong Kong/g, 'the United States');
      }
    }
  }

  function inject() {
    // Replace HK text in announcement + trust bar + main content (skip <script>, <style>)
    var announce =
      document.querySelector('aside.announcement-bar') ||
      document.querySelector('.shopify-section-header-announcements') ||
      document.querySelector('#header-group > :first-child');
    replaceHKText(announce);
    replaceHKText(document.querySelector('.kw-trust-bar'));
    replaceHKText(document.querySelector('#MainContent'));

    // Header trust strip — insert right after the announcement bar
    if (!document.getElementById('kw-trust-strip') && announce) {
      announce.insertAdjacentHTML('afterend', stripHtml());
    } else if (!document.getElementById('kw-trust-strip')) {
      var hg = document.getElementById('header-group');
      if (hg) hg.insertAdjacentHTML('beforeend', stripHtml());
    }

    // Footer trust — append inside footer element
    if (!document.getElementById('kw-footer-trust')) {
      var footer = document.querySelector('footer');
      if (footer) footer.insertAdjacentHTML('beforeend', footerHtml());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  // Re-inject on Shopify section rendering (theme editor)
  document.addEventListener('shopify:section:load', inject);

  // -------- Review card enhancer: extras gallery + video --------
  function enhanceReviews() {
    var dataEl = document.getElementById('kwrData');
    if (!dataEl) return;
    var payload;
    try { payload = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var all = (payload && payload.reviews) || [];
    // Build lookup by title+date+customer (stable key)
    var lookup = {};
    all.forEach(function (r) {
      var k = (r.t || '') + '|' + (r.d || '') + '|' + (r.c || '');
      lookup[k] = r;
    });

    function attach() {
      var cards = document.querySelectorAll('.kwr__card');
      if (!cards.length) return false;
      cards.forEach(function (card) {
        if (card.dataset.kwEnhanced === '1') return;
        var titleEl = card.querySelector('.kwr__c-title');
        var dateEl = card.querySelector('.kwr__date');
        var metaEl = card.querySelector('.kwr__meta');
        if (!titleEl || !dateEl || !metaEl) return;
        var title = titleEl.textContent.trim();
        var date = dateEl.textContent.trim();
        var customerName = (metaEl.textContent.trim().split('·')[0] || '').trim();
        var key = title + '|' + date + '|' + customerName;
        var rv = lookup[key];
        if (!rv) return;
        card.dataset.kwEnhanced = '1';

        // Video review: replace img with video
        if (rv.video) {
          var existingImg = card.querySelector('.kwr__c-img');
          var videoHtml =
            '<div class="kwr__c-img"><video src="' + rv.video + '" poster="' + (rv.img || '') + '"' +
            ' controls playsinline preload="metadata" style="width:100%;max-height:520px;border-radius:6px;background:#111;"></video></div>';
          if (existingImg) existingImg.outerHTML = videoHtml;
          else {
            var body = card.querySelector('.kwr__c-body');
            if (body) body.insertAdjacentHTML('afterend', videoHtml);
          }
        }

        // Extras gallery
        if (rv.extras && rv.extras.length) {
          var extraHtml = '<div class="kwr__c-extras" style="display:grid;grid-template-columns:repeat(' + Math.min(rv.extras.length, 4) + ',1fr);gap:6px;margin:8px 0 12px;">';
          rv.extras.forEach(function (u) {
            extraHtml += '<img src="' + u + '" alt="Customer photo" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:4px;background:#efe9dc;cursor:pointer;" onclick="this.requestFullscreen&&this.requestFullscreen()">';
          });
          extraHtml += '</div>';
          var slot = card.querySelector('.kwr__c-img') || card.querySelector('.kwr__c-body');
          if (slot) slot.insertAdjacentHTML('afterend', extraHtml);
        }
      });
      return true;
    }

    // Reviews might render after our script. Retry every 400ms up to 20 times.
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (attach() || tries > 20) clearInterval(t);
    }, 400);

    // Also re-attach on sort/filter changes (kwrList content refresh)
    var listEl = document.getElementById('kwrList');
    if (listEl) {
      var mo = new MutationObserver(function () {
        // Reset dataset then re-attach
        document.querySelectorAll('.kwr__card').forEach(function(c){ delete c.dataset.kwEnhanced; });
        setTimeout(attach, 50);
      });
      mo.observe(listEl, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceReviews);
  } else {
    enhanceReviews();
  }

  // -------- Personalization live-preview customizer (product page) --------
  function injectCustomizer() {
    // Only on product page
    if (!document.querySelector('main[data-template="product"]')) return;
    if (document.getElementById('kw-customizer')) return;

    // Find product form (Shopify submit form)
    var form = document.querySelector('product-form-component form, form[data-type="add-to-cart-form"], form[action="/cart/add"]');
    if (!form) return;
    var addBtn = form.querySelector('add-to-cart-component, .add-to-cart-button, button[name="add"]');
    if (!addBtn) return;

    var html =
'<div id="kw-customizer" style="margin:24px 0;padding:20px 22px;background:linear-gradient(180deg,#F4EFE4 0%,#EFE9DC 100%);border:1px solid #e0dcd0;border-radius:10px;font-family:-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif;">' +
'  <div style="display:flex;align-items:center;gap:10px;margin-bottom:6px;">' +
'    <span style="width:22px;height:22px;background:#4A2E1A;color:#fff;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;">✎</span>' +
'    <span style="font-size:0.78rem;letter-spacing:0.18em;text-transform:uppercase;color:#4A2E1A;font-weight:600;">Personalize your keepsake</span>' +
'  </div>' +
'  <p style="margin:0 0 16px;font-size:0.85rem;color:#6a6a6a;line-height:1.55;">Free personalization included. Names and date are hand-engraved, then charcoal-burned to last a lifetime. Preview updates as you type.</p>' +
'  <div style="display:flex;flex-direction:column;gap:12px;">' +
'    <label style="display:flex;flex-direction:column;gap:6px;">' +
'      <span style="font-size:0.72rem;letter-spacing:0.14em;text-transform:uppercase;color:#4A2E1A;font-weight:600;">Names <span style="color:#8a8a8a;font-weight:400;text-transform:none;letter-spacing:0.02em">(optional)</span></span>' +
'      <input id="kwc-input-name" name="properties[Engraved Names]" type="text" maxlength="30" placeholder="MICHAEL & SARAH" autocomplete="off" style="padding:11px 14px;border:1px solid #d5d0c2;border-radius:6px;background:#fff;font-size:0.95rem;color:#1c1c1c;font-family:Georgia,serif;letter-spacing:0.5px;outline:none;box-sizing:border-box;width:100%;">' +
'    </label>' +
'    <label style="display:flex;flex-direction:column;gap:6px;">' +
'      <span style="font-size:0.72rem;letter-spacing:0.14em;text-transform:uppercase;color:#4A2E1A;font-weight:600;">Date <span style="color:#8a8a8a;font-weight:400;text-transform:none;letter-spacing:0.02em">(optional)</span></span>' +
'      <input id="kwc-input-date" name="properties[Engraved Date]" type="text" maxlength="20" placeholder="JUNE 14, 2024" autocomplete="off" style="padding:11px 14px;border:1px solid #d5d0c2;border-radius:6px;background:#fff;font-size:0.95rem;color:#1c1c1c;font-family:Georgia,serif;letter-spacing:0.5px;outline:none;box-sizing:border-box;width:100%;">' +
'    </label>' +
'    <p id="kwc-status" style="margin:4px 0 0;font-size:0.75rem;color:#7a7a7a;line-height:1.5;">Add now, personalize later — or fill both fields to lock your engraving in.</p>' +
'  </div>' +
'  <style>#kw-customizer input:focus{border-color:#4A2E1A;box-shadow:0 0 0 3px rgba(74,46,26,0.12)}</style>' +
'</div>';

    addBtn.insertAdjacentHTML('beforebegin', html);

    var nameEl = document.getElementById('kwc-input-name');
    var dateEl = document.getElementById('kwc-input-date');
    var status = document.getElementById('kwc-status');

    // Load from localStorage
    try {
      var saved = JSON.parse(localStorage.getItem('kw-customizer') || '{}');
      if (saved.name) nameEl.value = saved.name;
      if (saved.date) dateEl.value = saved.date;
    } catch(e){}

    function updateStatus() {
      var n = nameEl.value.trim();
      var d = dateEl.value.trim();
      try { localStorage.setItem('kw-customizer', JSON.stringify({name: n, date: d})); } catch(e){}
      if (n && d) {
        status.textContent = '✓ Your engraving is set. Add to cart to submit.';
        status.style.color = '#00805a';
      } else if (n || d) {
        status.textContent = 'Add now — we\'ll email you to confirm the missing detail before we carve.';
        status.style.color = '#7a7a7a';
      } else {
        status.textContent = 'Add now, personalize later — or fill both fields to lock your engraving in.';
        status.style.color = '#7a7a7a';
      }
    }

    nameEl.addEventListener('input', updateStatus);
    dateEl.addEventListener('input', updateStatus);
    updateStatus();
  }

  function tryInjectCustomizer() {
    var tries = 0;
    var t = setInterval(function(){
      tries++;
      injectCustomizer();
      if (document.getElementById('kw-customizer') || tries > 20) clearInterval(t);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInjectCustomizer);
  } else {
    tryInjectCustomizer();
  }

  // -------- Site-wide motion: hero Ken Burns + parallax + fade-in on scroll --------
  function injectMotionStyles() {
    if (document.getElementById('kw-motion-styles')) return;
    var css =
      '@keyframes kwKenBurns { 0% { transform:scale(1.05) translate(0,0); } 100% { transform:scale(1.18) translate(-1.2%,-1.5%); } }' +
      '@keyframes kwFadeUp { 0% { opacity:0; transform:translateY(24px); } 100% { opacity:1; transform:none; } }' +
      '@keyframes kwFadeIn { 0% { opacity:0; } 100% { opacity:1; } }' +
      '@keyframes kwScrollHint { 0%,100% { transform:translateY(0); opacity:0.8; } 50% { transform:translateY(6px); opacity:0.3; } }' +
      /* Hero image Ken Burns */
      '.shopify-section-template--27671795236937__hero_infinity media-block img,' +
      '.shopify-section [id*="hero_infinity"] media-block img {' +
      '  animation: kwKenBurns 20s ease-in-out infinite alternate; transform-origin:center;' +
      '}' +
      /* Hero title + button fade-in staggered */
      '.shopify-section [id*="hero_infinity"] .text-block { animation: kwFadeUp 1.2s ease-out both; }' +
      '.shopify-section [id*="hero_infinity"] .text-block:nth-child(1) { animation-delay: 0.15s; }' +
      '.shopify-section [id*="hero_infinity"] .text-block:nth-child(2) { animation-delay: 0.35s; }' +
      '.shopify-section [id*="hero_infinity"] a.button-primary { animation: kwFadeUp 1s ease-out 0.55s both; }' +
      /* Scroll hint indicator */
      '#kw-scroll-hint { position:absolute; left:50%; bottom:24px; transform:translateX(-50%); z-index:5;' +
      '  color:#4A2E1A; font-size:0.7rem; letter-spacing:0.2em; text-transform:uppercase; font-weight:600;' +
      '  font-family:-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif; pointer-events:none;' +
      '  animation: kwScrollHint 2.2s ease-in-out infinite; opacity:0.75;' +
      '}' +
      '#kw-scroll-hint::after { content:""; display:block; width:1px; height:22px; margin:6px auto 0; background:#4A2E1A; }' +
      /* Fade-up-on-scroll (attached via IntersectionObserver) */
      '.kw-reveal { opacity:0; transform:translateY(30px); transition:opacity 0.85s cubic-bezier(0.22,0.61,0.36,1), transform 0.85s cubic-bezier(0.22,0.61,0.36,1); will-change:opacity,transform; }' +
      '.kw-reveal.kw-in { opacity:1; transform:none; }' +
      /* Product card hover lift */
      '.product-card { transition: transform 0.35s cubic-bezier(0.22,0.61,0.36,1), box-shadow 0.35s ease; }' +
      '.product-card:hover { transform: translateY(-4px); box-shadow: 0 10px 24px rgba(28,28,28,0.10); }' +
      /* Softer card image scale-in on hover */
      '.product-card .card-gallery img { transition: transform 0.7s cubic-bezier(0.22,0.61,0.36,1); }' +
      '.product-card:hover .card-gallery img { transform: scale(1.04); }' +
      /* Lifestyle gallery item lift */
      '.kw-lg__card { transition: transform 0.5s cubic-bezier(0.22,0.61,0.36,1); overflow:hidden; }' +
      '.kw-lg__card:hover { transform: translateY(-3px); }' +
      '.kw-lg__card img { transition: transform 1.2s cubic-bezier(0.22,0.61,0.36,1); }' +
      '.kw-lg__card:hover img { transform: scale(1.06); }' +
      /* Chapter cards in brand story: subtle lift */
      '.kw-story__ch { transition: transform 0.35s ease; }' +
      '.kw-story__ch:hover { transform: translateY(-3px); }' +
      /* Reduce motion */
      '@media (prefers-reduced-motion: reduce) {' +
      '  .kw-reveal, .kw-reveal.kw-in { opacity:1 !important; transform:none !important; transition:none !important; }' +
      '  #kw-scroll-hint, .shopify-section [id*="hero_infinity"] media-block img { animation:none !important; }' +
      '}';
    var s = document.createElement('style');
    s.id = 'kw-motion-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function injectScrollHint() {
    if (document.getElementById('kw-scroll-hint')) return;
    var hero = document.querySelector('[id*="hero_infinity"] section, [id*="hero_infinity"] .shopify-section, [id*="hero_infinity"]');
    if (!hero) return;
    // Only on homepage hero
    if (!document.querySelector('main[data-template="index"]')) return;
    var hint = document.createElement('div');
    hint.id = 'kw-scroll-hint';
    hint.textContent = 'Scroll';
    // Attach to first section wrapper with position:relative
    var target = document.querySelector('[id*="hero_infinity"]');
    if (target) {
      target.style.position = target.style.position || 'relative';
      target.appendChild(hint);
    }
  }

  function initRevealOnScroll() {
    if (!('IntersectionObserver' in window)) return;
    var selectors = [
      '[id*="editorial_craft"] .text-block',
      '[id*="editorial_lifestyle"] .text-block',
      '[id*="editorial_lifestyle"] a.button-primary',
      '.kw-pos__caption', '.kw-pos__h', '.kw-pos__sub',
      '.kw-story__eyebrow', '.kw-story__title', '.kw-story__intro',
      '.kw-story__ch',
      '.kw-lg__eyebrow', '.kw-lg__title', '.kw-lg__card',
      '.tp-card', '.tp-review',
      '.kwr__title', '.kwr__sub', '.kwr__summary',
      '[id*="explore_collection"] .text-block',
      '[id*="explore_collection"] a.button-primary',
      '[id*="collection_grid"] .product-grid__item',
      '.kw-trust-bar__item',
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        if (el.classList.contains('kw-reveal')) return;
        el.classList.add('kw-reveal');
        el.style.transitionDelay = Math.min(i, 5) * 0.06 + 's';
      });
    });
    var scrollRoot = document.querySelector('.page-wrapper');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kw-in');
          io.unobserve(entry.target);
        }
      });
    }, { root: scrollRoot || null, threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.kw-reveal').forEach(function (el) { io.observe(el); });
  }

  function initMotion() {
    injectMotionStyles();
    injectScrollHint();
    initRevealOnScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion);
  } else {
    initMotion();
  }
})();
